import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SuccessComponent } from './pages/success/success.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { CancelComponent } from './pages/cancel/cancel.component';
import { VersionComponent } from './pages/version/version.component';

const routes: Routes = [
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: 'success',
    component: SuccessComponent,
  },
  {
    path: 'cancel',
    component: CancelComponent,
  },
  {
    path: 'version',
    component: VersionComponent,
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/checkout/checkout.module').then(m => m.CheckoutModule),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
